import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function RockStarIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M28.2488 21.3715H23.848L23.0859 16.6378L20.2586 21.323H15.8086L18.513 24.139L16.3003 28.8727L21.1682 26.0082L24.9789 28.9213L24.266 24.139"
        fill="currentColor"
      />
      <path
        d="M31 20.4646H24.5167L23.488 14.0866L19.7081 20.4173H18.9904C18.5598 19.685 18.3923 18.622 18.3923 17.9606C18.3923 16.874 18.4641 15.811 18.4641 14.4173C18.4641 12.5748 17.9139 11.6063 16.4545 11.252V11.2047C19.5407 10.7795 20.9522 8.74803 20.9522 5.91339C20.9522 1.87402 18.2249 1 14.6603 1H5.06699L1 19.9921H6.09569L7.57895 13.0709H10.9761C12.7943 13.0709 13.5359 13.9449 13.5359 15.622C13.5359 16.8976 13.3923 17.9134 13.3923 18.8819C13.3923 19.2362 13.4641 20.0866 13.7273 20.4173L17.4115 24.2677L14.2297 31L21.0239 27.0079L26.0957 30.8583L25.1627 24.5039L31 20.4646ZM12.5072 9.52756H8.44019L9.42105 4.94488H13.201C14.5407 4.94488 15.9522 5.29921 15.9522 6.90551C15.9522 8.96063 14.3493 9.52756 12.5072 9.52756ZM21.1196 25.8976L16.3828 28.685L18.5598 24.1024L15.9282 21.3622H20.2584L22.9856 16.8031L23.7273 21.4094H28.0335L24.1579 24.0787L24.8517 28.7559L21.1196 25.8976Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
